module.exports = __webpack_public_path__ + "static/img/commissionBanner.83d42c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commissionBanner.png
// module id = K+Ea
// module chunks = 2